module.exports = __webpack_public_path__ + "static/media/HeroImage.03f1f7cd.jpg";